import { useTranslation } from 'react-i18next'

import { LANGUAGE } from '@/domains/CommonDomain'

export function useLang() {
  const { i18n } = useTranslation()
  const { language } = i18n
  const isID = language === LANGUAGE.IN

  return { language, isID }
}
